import { WidgetData, WidgetType } from "../types";

export function generateDefaultWidgets(tab: string = 'call-metrics'): WidgetData[] {
  switch (tab) {
    case 'call-metrics':
      return [
        {
          id: "widget-1",
          type: WidgetType.CALL_VOLUMES,
          title: "Total Inbound Calls",
          value: 1220,
          subtitle: "current month",
          description: "Total number of inbound calls",
          layout: { i: "widget-1", x: 0, y: 0, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-2",
          type: WidgetType.CALL_VOLUMES,
          title: "Total Outbound Calls",
          value: 850,
          subtitle: "current month",
          description: "Total number of outbound calls",
          layout: { i: "widget-2", x: 3, y: 0, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-3",
          type: WidgetType.CALL_VOLUMES,
          title: "Total Internal Calls",
          value: 450,
          subtitle: "current month",
          description: "Total number of internal calls",
          layout: { i: "widget-3", x: 6, y: 0, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-4",
          type: WidgetType.CALL_VOLUMES,
          title: "Total Abandoned Calls",
          value: 120,
          subtitle: "current month",
          description: "Total number of abandoned calls",
          layout: { i: "widget-4", x: 9, y: 0, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-5",
          type: WidgetType.CALL_VOLUMES,
          title: "Total Forwarded Calls",
          value: 180,
          subtitle: "current month",
          description: "Total number of forwarded calls",
          layout: { i: "widget-5", x: 0, y: 2, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-6",
          type: WidgetType.AGENT_AVAILABILITY,
          title: "SLA (%)",
          value: "87%",
          subtitle: "current status",
          description: "Service Level Agreement percentage",
          thresholds: {
            warning: 50,
            attention: 70,
          },
          maxValue: 100,
          layout: { i: "widget-6", x: 3, y: 2, w: 3, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-7",
          type: WidgetType.CALL_WAIT_TIME,
          title: "Average Waiting Time",
          value: "1:45",
          subtitle: "average in seconds",
          description: "Average time callers wait before being connected",
          layout: { i: "widget-7", x: 6, y: 2, w: 3, h: 2, minW: 2, minH: 2 }
        }
      ];

    case 'agent-performance':
      return [
        {
          id: "widget-1",
          type: WidgetType.AGENT_PRESENCE,
          title: "Total Agents",
          value: 25,
          subtitle: "active agents",
          description: "Total number of active agents",
          layout: { i: "widget-1", x: 0, y: 0, w: 6, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-2",
          type: WidgetType.AGENT_PERFORMANCE,
          title: "Top Performer",
          value: "John Doe",
          subtitle: "this month",
          description: "Best performing agent",
          layout: { i: "widget-2", x: 6, y: 0, w: 6, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-3",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Inbound Calls Handled",
          value: 850,
          subtitle: "this month",
          description: "Total inbound calls handled by agents",
          layout: { i: "widget-3", x: 0, y: 2, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-4",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Inbound Calls Missed",
          value: 45,
          subtitle: "this month",
          description: "Total inbound calls missed by agents",
          layout: { i: "widget-4", x: 4, y: 2, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-5",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Outbound Calls Handled",
          value: 620,
          subtitle: "this month",
          description: "Total outbound calls handled by agents",
          layout: { i: "widget-5", x: 8, y: 2, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-6",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Outbound Calls Missed",
          value: 30,
          subtitle: "this month",
          description: "Total outbound calls missed by agents",
          layout: { i: "widget-6", x: 0, y: 4, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-7",
          type: WidgetType.CALL_WAIT_TIME,
          title: "Average Handling Time",
          value: "3:15",
          subtitle: "per call",
          description: "Average time spent handling calls",
          layout: { i: "widget-7", x: 4, y: 4, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-8",
          type: WidgetType.AGENT_AVAILABILITY,
          title: "Average SLA (%)",
          value: "92%",
          subtitle: "this month",
          description: "Average Service Level Agreement percentage",
          thresholds: {
            warning: 50,
            attention: 70,
          },
          maxValue: 100,
          layout: { i: "widget-8", x: 8, y: 4, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-9",
          type: WidgetType.AGENT_PERFORMANCE,
          title: "SLA Performance Ranking",
          value: "Top 5 Agents",
          subtitle: "by SLA achievement",
          description: "Ranking of agents based on SLA performance",
          layout: { i: "widget-9", x: 0, y: 6, w: 6, h: 3, minW: 4, minH: 2 }
        },
        {
          id: "widget-10",
          type: WidgetType.AGENT_STATUS_OVER_TIME,
          title: "Status Over Time",
          value: "24h",
          subtitle: "agent status tracking",
          description: "Historical view of agent status changes",
          layout: { i: "widget-10", x: 6, y: 6, w: 6, h: 3, minW: 4, minH: 2 }
        },
        {
          id: "widget-11",
          type: WidgetType.AGENT_PERFORMANCE_TABLE,
          title: "Agent Performance Table",
          value: "25 Agents",
          subtitle: "detailed metrics",
          description: "Comprehensive performance metrics for all agents",
          layout: { i: "widget-11", x: 0, y: 9, w: 12, h: 4, minW: 6, minH: 3 }
        },
        {
          id: "widget-12",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Internal Calls",
          value: 320,
          subtitle: "this month",
          description: "Total number of internal calls handled",
          layout: { i: "widget-12", x: 0, y: 13, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-13",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Total Forwarded Calls",
          value: 150,
          subtitle: "this month",
          description: "Total number of forwarded calls",
          layout: { i: "widget-13", x: 4, y: 13, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-14",
          type: WidgetType.CALL_WAIT_TIME,
          title: "Average Speed of Answer",
          value: "0:45",
          subtitle: "per call",
          description: "Average time to answer incoming calls",
          layout: { i: "widget-14", x: 8, y: 13, w: 4, h: 2, minW: 2, minH: 2 }
        },
        {
          id: "widget-15",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Average Calls Per Agent Trend",
          value: 68,
          subtitle: "this month",
          description: "Average number of calls handled per agent",
          layout: { i: "widget-15", x: 0, y: 15, w: 4, h: 2, minW: 2, minH: 2 }
        }
      ];

    case 'trends-insights':
      return [
        {
          id: "widget-1",
          type: WidgetType.CALL_VOLUMES,
          title: "Call Volume Trend",
          value: 2500,
          subtitle: "this month",
          description: "Trend of call volumes over time",
          layout: { i: "widget-1", x: 0, y: 0, w: 12, h: 3, minW: 6, minH: 3 }
        },
        {
          id: "widget-2",
          type: WidgetType.INBOUND_STATUS_DISTRIBUTION,
          title: "Call Status Distribution Trend",
          value: "Distribution",
          subtitle: "trend",
          description: "Trend of call status distribution over time",
          layout: { i: "widget-2", x: 0, y: 3, w: 6, h: 3, minW: 4, minH: 3 }
        },
        {
          id: "widget-3",
          type: WidgetType.AVG_HANDLING_TIME,
          title: "Average Handle Time Trend",
          value: "2:30",
          subtitle: "average",
          description: "Trend of average handling time",
          layout: { i: "widget-3", x: 6, y: 3, w: 6, h: 3, minW: 4, minH: 3 }
        },
        {
          id: "widget-4",
          type: WidgetType.AGENT_DAILY_CALLS,
          title: "Average Calls Per Agent Trend",
          value: 72,
          subtitle: "trend",
          description: "Trend of average calls per agent",
          layout: { i: "widget-4", x: 0, y: 6, w: 6, h: 3, minW: 4, minH: 3 }
        },
        {
          id: "widget-5",
          type: WidgetType.AGENT_AVAILABILITY,
          title: "SLA (%) Trend",
          value: "89%",
          subtitle: "this month",
          description: "Trend of Service Level Agreement percentage",
          layout: { i: "widget-5", x: 6, y: 6, w: 6, h: 3, minW: 4, minH: 3 }
        },
        {
          id: "widget-6",
          type: WidgetType.CALLS_HANDLED_BY_QUEUE,
          title: "SLA by Call Queue",
          value: "SLA by Queue",
          subtitle: "trend",
          description: "SLA percentage by call queue",
          layout: { i: "widget-6", x: 0, y: 9, w: 12, h: 3, minW: 6, minH: 3 }
        }
      ];

    default:
      return [];
  }
}

export function getWidgetIcon(widgetType: WidgetType): string {
  switch (widgetType) {
    case WidgetType.CALL_VOLUMES:
      return "📞";
    case WidgetType.CALL_WAIT_TIME:
      return "⏱️";
    case WidgetType.AGENT_AVAILABILITY:
      return "👩‍💼";
    case WidgetType.CALLS_IN_QUEUE:
      return "🔄";
    case WidgetType.AGENT_DAILY_CALLS:
      return "📊";
    case WidgetType.AGENT_PRESENCE:
      return "👥";
    default:
      return "📊";
  }
}

export function getWidgetDescription(widgetType: WidgetType): string {
  switch (widgetType) {
    case WidgetType.CALL_VOLUMES:
      return "Total number of calls in the selected period";
    case WidgetType.CALL_WAIT_TIME:
      return "Average time callers wait before being connected";
    case WidgetType.AGENT_AVAILABILITY:
      return "Percentage of time agents are available";
    case WidgetType.CALLS_IN_QUEUE:
      return "Current number of calls waiting to be answered";
    case WidgetType.AGENT_DAILY_CALLS:
      return "Average number of calls handled per agent daily";
    case WidgetType.AGENT_PRESENCE:
      return "Percentage of agents currently online";
    default:
      return "Widget description";
  }
}

export function getValueColor(value: string | number, thresholds?: { warning: number, attention: number }): string {
  if (!thresholds) return "text-white";

  // Convert string percentage to number
  const numValue = typeof value === 'string' && value.includes('%')
    ? parseFloat(value)
    : Number(value);

  if (numValue < thresholds.warning) {
    return "text-warning";
  } else if (numValue < thresholds.attention) {
    return "text-attention";
  }
  return "text-success";
}
